import { ExerciseMetric } from "types";

const repCountMetric: ExerciseMetric = {
  isDefault: false,
  isPbEnabled: true,
  displayMetadata: { imperial: { decimals: 0, unit: null }, metric: { decimals: 0, unit: null } },
  name: "Completed Reps",
  field: "repCount",
  unitOfMeasure: "",
  sortType: 1,
};
export default repCountMetric;
